import React, { useState } from "react";
import { MdOutlineContentCopy } from "react-icons/md";
import "./pages.css";
import { useGetCountriesQuery } from "../store/api/recipientApi";
import { useTutorial } from "../hooks/useTutorial";
import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";


const Country = () => {
  const { data: countries = [], error: countriesError, isLoading: isLoadingCountries } = useGetCountriesQuery();
  const { token, loading } = useSelector((state) => state.auth);
  if (token) {

    var { client_code } = jwtDecode(token ?? "");
  }

  return (
    <div className="country">
      <div className="form-title">Адреса зарубежных складов </div>
      <div className="country-list">
        {
          countries.map(country => {
            return <div className="country_card" key={country.guid}>
              <div className="country_card" key={country.guid}>
                <div className="warehouse-card">
                  <div className="warehouse-card-content">
                    <div className="warehouse-card-flag">
                      <img src={`https://onza-api.ibm.kg${country.flag}`} alt="Flag" />
                    </div>
                    <div className="warehouse-card-text">
                      <div className="warehouse-row">
                        <span className="warehouse-label">Адресная строка 1:</span>
                        <span className="warehouse-value">{country.address_line}</span>
                        <button onClick={() => navigator.clipboard.writeText(country.address_line)}><MdOutlineContentCopy /></button>
                      </div>
                      <div className="warehouse-row">
                        <span className="warehouse-label">Адресная строка 2:</span>
                        <span className="warehouse-value">{country.address_line2} {client_code}</span>
                        <button onClick={() => navigator.clipboard.writeText(country.address_line2 + " " + client_code)}><MdOutlineContentCopy /></button>
                      </div>
                      <div className="warehouse-row">
                        <span className="warehouse-label">Город:</span>
                        <span className="warehouse-value">{country.city}</span>
                        <button onClick={() => navigator.clipboard.writeText(`${country.city}`)}><MdOutlineContentCopy /></button>
                      </div>
                      <div className="warehouse-row">
                        <span className="warehouse-label">Штат:</span>
                        <span className="warehouse-value">{country.state}</span>
                        <button onClick={() => navigator.clipboard.writeText(country.state)}><MdOutlineContentCopy /></button>
                      </div>
                      <div className="warehouse-row">
                        <span className="warehouse-label">Почтовый индекс:</span>
                        <span className="warehouse-value">{country.postcode}</span>
                        <button onClick={() => navigator.clipboard.writeText(country.postcode)}><MdOutlineContentCopy /></button>
                      </div>
                      <div className="warehouse-row">
                        <span className="warehouse-label">Телефон склада:</span>
                        <span className="warehouse-value">{country.phone}</span>
                        <button onClick={() => navigator.clipboard.writeText(country.phone)}><MdOutlineContentCopy /></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          })
        }
      </div>
    </div>
  );
};

export default Country;
